'use client';

import type { TotemWithLocation } from '@/features/totems/presentation/actions/web-totem/get-totem-with-location';
import { MpStaticQrBadge } from '@/features/totems/presentation/components/take-order/mp-static-qr-badge';
import { PrintersStatusBadge } from '@/features/totems/presentation/components/take-order/printers-status-badge';
import { PrintingInProgressBadge } from '@/features/totems/presentation/components/take-order/printing-in-progress-badge';

interface Props {
  totem?: TotemWithLocation | null;
}

export function TakeOrderStatusBar({ totem }: Props) {
  if (!totem) return null;

  return (
    <div className="flex items-center gap-1.5 overflow-x-auto py-1">
      {/* 1. Impresora Local y Pruebas Mock (Unificado) */}
      <PrintersStatusBadge locationSlug={totem.locations?.slug} />

      {/* 2. QR de Mercado Pago del PDV */}
      <MpStaticQrBadge totemId={totem.id} staticQrEnabled={Boolean(totem.static_qr)} />

      {/* 3. Indicador de Impresión en Curso en Segundo Plano */}
      <PrintingInProgressBadge />
    </div>
  );
}
